export const getValidCountryCode = (countryCode) => countryCode || 'global';
export const getValidMissionSlug = (missionSlug) => missionSlug || 'all';
